import { ReferralSchema } from '../data/types';

/** Download minimized referral scorecard rows as CSV. */
export const downloadReferralCsv = (items: ReferralSchema[]) => {
  const header = ['business', 'status', 'channel', 'code', 'fit_score', 'created'];
  const rows = items.map((item) => [
    item.payload?.business_name || item.payload?.name || '',
    item.status || '',
    item.channel || '',
    item.referral_code || '',
    String(item.qualification?.fit_score ?? ''),
    item.created || '',
  ]);
  const csv = [header, ...rows]
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'homecook-airiwheels-referrals.csv';
  link.click();
  URL.revokeObjectURL(url);
};
